import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import {
  AlertActionType,
  IAlertAction,
  IAlertActionEvent,
  IAlertMessageConfig
} from '../../models/IAlertMessageConfig';
import { CommonAuthService } from '@libs/common-services';

@Component({
  selector: 'lib-ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})
export class AlertComponent {
  @Input() message!: IAlertMessageConfig;
  @Output() eventAction = new EventEmitter<IAlertActionEvent>();

  #authService = inject(CommonAuthService);

  publishAction(eventId: string): void {
    this.eventAction.emit({ eventId });
  }

  private readonly userEmail = this.#authService.getUser()?.getEmail();

  get primaryActions(): IAlertAction[] {
    return this.message.alertActions.filter(
      (action) =>
        AlertActionType.primary === action.type &&
        (!action.viewFor ||
          (this.userEmail && action.viewFor.includes(this.userEmail)))
    );
  }

  get secondaryActions(): IAlertAction[] {
    return this.message.alertActions.filter(
      (action) =>
        AlertActionType.secondary === action.type &&
        (!action.viewFor ||
          (this.userEmail && action.viewFor.includes(this.userEmail)))
    );
  }
}
